Controller.$inject = [];

function Controller() {

}

export function HuiProgressGroup() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            sizing: '@',
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: {
            'label': '?huiProgressGroupLabel',
            'lines': '?huiProgressGroupLines',
            'description': '?huiProgressGroupDescription'
        },
        template: ($element, $attrs) => {
            return `
                <div class="hui hui-progress-group"
                     ng-class="[$huiCtrl.sizing || 'md']" >
                    <ng-transclude ng-transclude-slot="label" class="progress-group-title"></ng-transclude>
                    <div class="position-relative w-100">
                         <div class="progress-group-separator"></div>
                         <ng-transclude class="hui-progress-group-lines" ng-transclude-slot="lines"></ng-transclude>
                         <ng-transclude class="hui-progress-group-description" ng-transclude-slot="description"></ng-transclude>
                    </div>
                </div>
            `;
        }
    }
}